import React from 'react'
export default class MessageArchiveRecordLockedModal extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    if (this.props.archive_association_array != null) {
      var association_lines = this.props.archive_association_array.map((association, idx) => {
        return  (
          <li key={idx}>{association}</li>
        )
      })
    } else {
      
    }
    
    return (
      <div className={`alert ${this.props.additional_classes ? this.props.additional_classes : ''}`}>
        <h4 style={{ marginTop: '5px', textAlign: 'center' }}><strong><span className="ss-lock"></span>{` ${I18n.t('record_locked')}`}</strong></h4>
        <hr/>
        <div className='form-group'>

          <p className="text-center">{this.props.message}</p>
          <ul>
            {association_lines}
          </ul>
        </div>
      
      </div>
    );
  };
}